import { render, staticRenderFns } from "./CreateRecipeProcedure.vue?vue&type=template&id=5a91dd88&"
import script from "./CreateRecipeProcedure.vue?vue&type=script&lang=ts&"
export * from "./CreateRecipeProcedure.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports